import useProjectListingsPopup from '@resources/js/app/composables/useProjectListingsPopup.js';
import useListingCardPopup from '@resources/js/app/composables/useListingCardPopup.js';
import set from 'lodash.set';

const LISTING_ID = 0;
const LISTING_COORDINATES = 1;
const LISTING_TEXT = 2;
const LISTING_PROMOTIONS = 4;
const CLUSTER_SIZE = 8;
const PROJECT_LISTINGS = 8;
const LISTING_IS_HOVER = 100;
const LISTING_IS_AGENCY = 101;

export default function useCustomMarker() {
    const { getProjectPopup } = useProjectListingsPopup();
    const { getListingPopup } = useListingCardPopup();

    const getMarkerByLayerType = (pin, type, map, extraData, isMobile, setShowListingDetails, selectEntity) => {
        const coords = pin[LISTING_COORDINATES];
        const latLng = [coords[1], coords[0]];
        let iconW = null,
            iconH = null,
            iconFontSize = null,
            zIndex = null,
            displayPrice = true;

        if (pin[LISTING_PROMOTIONS].includes('top_listing_s')) {
            iconW = 70;
            iconH = 36;
            iconFontSize = 14;
            zIndex = 900;
        } else if (
            (pin[LISTING_PROMOTIONS].includes('top_listing') && pin[LISTING_PROMOTIONS].includes('energy')) ||
            pin[LISTING_PROMOTIONS].includes('top_listing_energy')
        ) {
            iconW = 65;
            iconH = 34;
            iconFontSize = 12;
            zIndex = 800;
        } else if (pin[LISTING_PROMOTIONS].includes('top_listing')) {
            iconW = 60;
            iconH = 32;
            iconFontSize = 12;
            zIndex = 700;
        } else if (pin[LISTING_PROMOTIONS].includes('starter')) {
            iconW = 50;
            iconH = 26;
            iconFontSize = 10;
            zIndex = 600;
        } else if (pin[LISTING_PROMOTIONS].includes('listings_projects')) {
            iconW = 40;
            iconH = 50;
            zIndex = 800;
        } else {
            iconW = 22;
            iconH = 28;
            zIndex = 500;
            displayPrice = false;
        }

        let text = pin[LISTING_TEXT] || '';
        let textLength = text.length;
        if (type == 'listings_projects') {
            text = `<svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_8801_119990)">
                <path d="M21.56 21.12H21.12V14.3C21.1199 14.1065 21.0773 13.9154 20.9952 13.7402C20.9131 13.5651 20.7934 13.4101 20.6448 13.2862L18.48 11.4814V3.96C18.48 3.60991 18.3409 3.27417 18.0934 3.02662C17.8458 2.77907 17.5101 2.64 17.16 2.64H15.84V1.32C15.84 0.969914 15.7009 0.634167 15.4534 0.386619C15.2058 0.139071 14.8701 0 14.52 0L9.23998 0C8.88989 0 8.55415 0.139071 8.3066 0.386619C8.05905 0.634167 7.91998 0.969914 7.91998 1.32V2.64H6.59998C6.24989 2.64 5.91415 2.77907 5.6666 3.02662C5.41905 3.27417 5.27998 3.60991 5.27998 3.96V21.12H2.63998V15.7872C3.17741 15.6101 3.6413 15.2605 3.95957 14.7926C4.27784 14.3248 4.43267 13.7649 4.39998 13.2C4.45276 12.5594 4.25173 11.9236 3.84021 11.4298C3.42869 10.936 2.83964 10.6236 2.19998 10.56C1.56032 10.6236 0.971266 10.936 0.559748 11.4298C0.148231 11.9236 -0.0527995 12.5594 -1.9785e-05 13.2C-0.0327049 13.7649 0.122117 14.3248 0.440386 14.7926C0.758656 15.2605 1.22255 15.6101 1.75998 15.7872V21.12H0.43998C0.323285 21.12 0.211369 21.1664 0.128853 21.2489C0.0463372 21.3314 -1.9785e-05 21.4433 -1.9785e-05 21.56C-1.9785e-05 21.6767 0.0463372 21.7886 0.128853 21.8711C0.211369 21.9536 0.323285 22 0.43998 22H21.56C21.6767 22 21.7886 21.9536 21.8711 21.8711C21.9536 21.7886 22 21.6767 22 21.56C22 21.4433 21.9536 21.3314 21.8711 21.2489C21.7886 21.1664 21.6767 21.12 21.56 21.12ZM0.87998 13.2C0.87998 12.2461 1.48454 11.44 2.19998 11.44C2.91542 11.44 3.51998 12.2461 3.51998 13.2C3.51998 14.1539 2.91542 14.96 2.19998 14.96C1.48454 14.96 0.87998 14.1539 0.87998 13.2ZM17.16 3.52C17.2767 3.52 17.3886 3.56636 17.4711 3.64887C17.5536 3.73139 17.6 3.8433 17.6 3.96V10.7483L16.6848 9.98624C16.4477 9.7885 16.1487 9.68014 15.84 9.68V3.52H17.16ZM8.79998 1.32C8.79998 1.2033 8.84634 1.09139 8.92885 1.00887C9.01137 0.926357 9.12328 0.88 9.23998 0.88H14.52C14.6367 0.88 14.7486 0.926357 14.8311 1.00887C14.9136 1.09139 14.96 1.2033 14.96 1.32V10.0144L11.0352 13.288C10.8867 13.4116 10.7673 13.5663 10.6851 13.7412C10.603 13.9161 10.5603 14.1068 10.56 14.3V21.12H8.79998V1.32ZM6.15998 21.12V3.96C6.15998 3.8433 6.20634 3.73139 6.28885 3.64887C6.37137 3.56636 6.48328 3.52 6.59998 3.52H7.91998V21.12H6.15998ZM14.08 21.12V16.72H17.6V21.12H14.08ZM18.48 21.12V16.72C18.48 16.4866 18.3873 16.2628 18.2222 16.0977C18.0572 15.9327 17.8334 15.84 17.6 15.84H14.08C13.8466 15.84 13.6228 15.9327 13.4577 16.0977C13.2927 16.2628 13.2 16.4866 13.2 16.72V21.12H11.44V14.3C11.44 14.2355 11.4542 14.1718 11.4816 14.1134C11.509 14.055 11.5488 14.0034 11.5984 13.9621L15.5584 10.6621C15.6374 10.5962 15.7371 10.5602 15.84 10.5602C15.9429 10.5602 16.0425 10.5962 16.1216 10.6621L20.0816 13.9621C20.1311 14.0034 20.171 14.055 20.1984 14.1134C20.2258 14.1718 20.24 14.2355 20.24 14.3V21.12H18.48Z" fill="white"/>
                <path d="M11.0001 4.40002H12.7601C12.8768 4.40002 12.9887 4.35366 13.0712 4.27115C13.1537 4.18863 13.2001 4.07671 13.2001 3.96002C13.2001 3.84332 13.1537 3.73141 13.0712 3.64889C12.9887 3.56638 12.8768 3.52002 12.7601 3.52002H11.0001C10.8834 3.52002 10.7714 3.56638 10.6889 3.64889C10.6064 3.73141 10.5601 3.84332 10.5601 3.96002C10.5601 4.07671 10.6064 4.18863 10.6889 4.27115C10.7714 4.35366 10.8834 4.40002 11.0001 4.40002Z" fill="white"/>
                <path d="M11.0001 7.04003H12.7601C12.8768 7.04003 12.9887 6.99368 13.0712 6.91116C13.1537 6.82865 13.2001 6.71673 13.2001 6.60003C13.2001 6.48334 13.1537 6.37142 13.0712 6.28891C12.9887 6.20639 12.8768 6.16003 12.7601 6.16003H11.0001C10.8834 6.16003 10.7714 6.20639 10.6889 6.28891C10.6064 6.37142 10.5601 6.48334 10.5601 6.60003C10.5601 6.71673 10.6064 6.82865 10.6889 6.91116C10.7714 6.99368 10.8834 7.04003 11.0001 7.04003Z" fill="white"/>
                <path d="M11.0001 9.68005H12.7601C12.8768 9.68005 12.9887 9.63369 13.0712 9.55118C13.1537 9.46866 13.2001 9.35674 13.2001 9.24005C13.2001 9.12335 13.1537 9.01144 13.0712 8.92892C12.9887 8.84641 12.8768 8.80005 12.7601 8.80005H11.0001C10.8834 8.80005 10.7714 8.84641 10.6889 8.92892C10.6064 9.01144 10.5601 9.12335 10.5601 9.24005C10.5601 9.35674 10.6064 9.46866 10.6889 9.55118C10.7714 9.63369 10.8834 9.68005 11.0001 9.68005Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_8801_119990">
                <rect width="22" height="22" fill="white"/>
                </clipPath>
                </defs>
            </svg>`;
            textLength = 1;
        }

        let iconClass =
            type === 'listings_projects'
                ? 'project-icon project-' + pin[LISTING_ID]
                : 'listing-icon listing-' + pin[LISTING_ID];

        iconClass += iconFontSize ? ' text-[' + iconFontSize + 'px]' : '';

        if (pin[LISTING_IS_AGENCY]) {
            iconClass += ' personal';
        }

        if (pin[LISTING_IS_HOVER]) {
            iconClass += ' hover';
        }

        iconW = Math.max(iconW, textLength * iconFontSize * 0.8);

        const icon = new L.divIcon({
            className: iconClass,
            html:
                '<div class="icon-wp' +
                (displayPrice ? '' : ' !rounded-full') +
                '">' +
                (displayPrice ? text : '<span class="dot"></span>') +
                '</div>',
            iconSize: [iconW, iconH],
            iconAnchor: [iconW / 2, iconH + 1],
        });

        const marker = new L.marker(latLng, {
            icon,
            id: pin[LISTING_ID],
            zIndexOffset: 1000 + zIndex,
            autoPanOnFocus: false,
        });

        if (pin[LISTING_IS_HOVER]) {
            marker.popupOpen = true;
        }

        marker.layer = type;
        marker.promotions = pin[LISTING_PROMOTIONS];
        marker.text = text;

        switch (type) {
            case 'listings_projects':
                marker.listingsCount = pin[PROJECT_LISTINGS].length;
                if (isMobile) {
                    marker.on('click', async e => {
                        setShowListingDetails(false);
                        await selectEntity(pin[LISTING_ID], 'project');
                        setShowListingDetails(true, pin[LISTING_ID]);
                    });
                } else {
                    marker.mouseOverPopup = event => {
                        map.scrollWheelZoom.disable();
                    };

                    marker.mouseLeavePopup = event => {
                        map.scrollWheelZoom.enable();

                        if (
                            event.relatedTarget.className != 'project-card__listing__wrapper__header' &&
                            event.relatedTarget.className != 'project-card__listing__wrapper' &&
                            event.relatedTarget.className != marker._icon?.className &&
                            !document
                                .querySelector('.project-card__listing__list-wrapper')
                                ?.classList?.contains('expand')
                        ) {
                            map.closePopup();
                        }
                    };

                    marker.openPopup = _marker => {
                        // Remove existing popup from DOM if any
                        document.querySelector('.project-card__listings__main-container')?.remove();

                        const pp = new L.Rrose({
                            className: 'project-card__listings__main-container',
                            offset: new L.point({ x: 0, y: 0 }),
                            closeButton: true,
                            closeOnClick: false,
                            autoPan: false,
                            marker: _marker,
                        });

                        pp.marker = _marker;
                        pp.setContent(getProjectPopup(pin, extraData)).setLatLng(_marker._latlng).openOn(map);

                        const container = document.querySelector('.project-card__listings__main-container');
                        const header = document.querySelector('.project-card__listing__wrapper__header');
                        const dropdownIcon = document.querySelector('.project-card__listing__detail--icon__header');
                        const ul = document.querySelector('.project-card__listing__list-wrapper');

                        container.addEventListener('mouseenter', _marker.mouseOverPopup);
                        container.addEventListener('mouseleave', _marker.mouseLeavePopup);
                        header.addEventListener('click', function () {
                            ul.classList.toggle('expand');
                            dropdownIcon.classList.toggle('rotate');
                            extraData['saveProjectMapRaoLogs'](pin[LISTING_ID]);
                        });
                    };

                    marker
                        .on('mouseout', e => {
                            e.target.mouseLeavePopup(e.originalEvent);
                        })
                        .on('mouseover', e => {
                            if (!e.target.popupOpen || !document.querySelector('.leaflet-rrose')) {
                                e.target.openPopup(e.target);
                            }
                        })
                        .on('click', () => {
                            const ppHeader = document.querySelector('.project-card__listing__wrapper__header');
                            if (ppHeader) {
                                ppHeader.click();
                            }
                        });
                }

                break;
            default:
                if (isMobile) {
                    marker
                        // Listing popup show/hide
                        .on('click', async function (e) {
                            setShowListingDetails(false);
                            await selectEntity(pin[LISTING_ID], 'listing');
                            setShowListingDetails(true, marker);
                        });
                } else {
                    marker
                        // Listing popup show/hide
                        .on('mousedown', async function (e) {
                            const content = await getListingPopup(
                                pin[LISTING_ID],
                                extraData,
                                extraData['getPopupData'],
                            );
                            if (content) {
                                if (e.target.popupOpen) {
                                    e.target.popupOpen = false;
                                    return;
                                }

                                const pp = new L.Rrose({
                                    className: 'listing-popup__main-container',
                                    offset: new L.point({ x: 0, y: -50 }),
                                    closeButton: true,
                                    autoPan: false,
                                    marker: e.target,
                                });

                                pp.marker = e.target;
                                pp.setContent(content).setLatLng(e.latlng).openOn(map);
                            }
                        })
                        // Location type info tooltip show/hide
                        .on('mouseover', e => {
                            e.target
                                .bindTooltip(extraData['locationEstimate'], {
                                    direction: 'top',
                                    offset: L.point({ x: 0, y: -35 }),
                                    opacity: 0.9,
                                    className: 'marker_tooltip',
                                })
                                .openTooltip();
                        })
                        .on('mouseout', e => {
                            e.target.unbindTooltip();
                        });
                }

                break;
        }

        return marker;
    };

    /* Pin used for projects search map */
    const getProjectMarker = pin => {
        const coords = pin[LISTING_COORDINATES];
        const latLng = [coords[1], coords[0]];
        let iconW = 30,
            iconH = 40,
            zIndex = 600;

        let iconClass = 'listing-icon red-project-icon project-' + pin[LISTING_ID];

        if (pin[LISTING_IS_HOVER]) {
            iconClass += ' hover';
        }

        const icon = new L.divIcon({
            className: iconClass,
            html: '<div class="icon-wp"><div class="dot"></div></div>',
            iconSize: [iconW, iconH],
            iconAnchor: [iconW / 2, iconH + 1],
        });

        const marker = new L.marker(latLng, {
            icon,
            id: pin[LISTING_ID],
            zIndexOffset: 1000 + zIndex,
        });

        if (pin[LISTING_IS_HOVER]) {
            marker.popupOpen = true;
        }

        return marker;
    };

    const getClusterMarker = (pin, map, isMobile) => {
        const coords = pin[LISTING_COORDINATES];
        const latLng = [coords[1], coords[0]];
        const childCount = pin[CLUSTER_SIZE];

        let dimension = 'xlarge';

        if (childCount < 1000) {
            dimension = 'large';
        }

        if (childCount < 300) {
            dimension = 'medium';
        }

        if (childCount < 100) {
            dimension = 'small';
        }

        if (childCount < 10) {
            dimension = 'xsmall';
        }

        const icon = L.divIcon({
            html: '<div class="cluster ' + dimension + '">' + childCount + '</div>',
        });

        const marker = new L.marker(latLng, {
            icon,
        });

        marker.clusterSize = pin[CLUSTER_SIZE];

        marker.on('click', e => {
            map.setView(e.target.getLatLng(), map.getZoom() + 2);
            dataLayerPush('map_prop_number', {
                listId: 'not applicable',
                prop_number: pin[CLUSTER_SIZE],
            });
        });

        if (!isMobile) {
            marker
                .on('mouseover', e => {
                    e.target
                        .bindTooltip('Click pentru a vedea anunțurile', {
                            direction: 'top',
                            opacity: 1,
                            className: 'marker_tooltip',
                            offset: L.point({ x: -5, y: -45 }),
                        })
                        .openTooltip();
                })
                .on('mouseout', e => {
                    e.target.unbindTooltip();
                });
        }

        return marker;
    };

    const dataLayerPush = (eventName, data) => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: eventName,
                ...data,
            });
        }
    };

    return {
        getMarkerByLayerType,
        getProjectMarker,
        getClusterMarker,
    };
}
